import { render, staticRenderFns } from "./editIcon.vue?vue&type=template&id=2bb85bde&scoped=true&"
import script from "./editIcon.vue?vue&type=script&lang=js&"
export * from "./editIcon.vue?vue&type=script&lang=js&"
import style0 from "./editIcon.vue?vue&type=style&index=0&id=2bb85bde&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb85bde",
  null
  
)

export default component.exports